import { render, staticRenderFns } from "./IconPreview.vue?vue&type=template&id=0878123a&scoped=true"
import script from "./IconPreview.vue?vue&type=script&lang=ts"
export * from "./IconPreview.vue?vue&type=script&lang=ts"
import style0 from "./IconPreview.vue?vue&type=style&index=0&id=0878123a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0878123a",
  null
  
)

export default component.exports